import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { IClientModel } from 'src/app/core/models/application.model';
import { IBackgroundFile, IBackgroundModel } from 'src/app/core/models/background.model';
import { IUser } from 'src/app/core/models/user.model';
import { ApplicationService } from 'src/app/core/services/application.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { ClientService } from 'src/app/core/services/client.service';
import { sharedDataService } from 'src/app/core/services/sharedData.service';
import { UserService } from 'src/app/core/services/user.service';
import { AddUserComponent } from 'src/app/shared/components/modals/add-user/add-user.component';
import { UtilService } from '../../../core/services/util/util.service';

@Component({
  selector: 'app-list-users',
  templateUrl: './list-users.component.html',
  styleUrls: ['./list-users.component.css']
})
export class ListUsersComponent implements OnInit {

  constructor(
    private userService: UserService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private router: Router,
    private sharedData: sharedDataService,
    private authService: AuthService,
    private applicationService: ApplicationService,
    private clientService: ClientService,
    private util: UtilService
  ) { }

  @ViewChild('dialogAddUser') private dialogAddUser: AddUserComponent;

  application: IClientModel;
  applicationsDataSearch: IClientModel[];
  selectedApp: IClientModel = null;
  searchParamApp: string;

  users: IUser[];
  currentUser: IUser;

  userToAddCredit: IUser;
  modalAddUserCredit;

  searchParam = '';
  usersDataSearch: IUser[];

  page = 1;
  perPage = 12;
  clientPage = 1;
  clientPerPage = 12;

  toggleAddUser = false;
  toggleAddClient = false;
  toggleNewClient = false;

  newBackgrounds: IBackgroundModel[];
  allNewBackgrounds: IBackgroundModel[];
  backgroundFiles: IBackgroundFile[] = [];
  backgroundSearch: IBackgroundModel[];
  showMyContainer = false;
  allBackgroundFiles: IBackgroundFile[] = [];
  searchBgParam: string;
  selectedBackgrounds: any[] = [];
  selectedBackground = 'Select backgrounds...';

  canSeeAdmins: boolean;

  presets: any;
  userPresets: any;
  showPresets = false;
  searchPresetsParam;
  presetsSearch;
  selectedPresets: any[] = [];
  selectedPreset = 'Select Preset...';

  searchPresetParam: string;
  presetToDelete: any;
  presetsList: any = [];

  filterOptions = [
    { label: '3+ Days ago', value: 3 },
    { label: '5+ Days ago', value: 5 },
    { label: '10+ Days ago', value: 10 },
  ];
  selectedFilter: number | null = null;

  ngOnInit(): void {
    this.authService.LoggedinUser
      .subscribe(
        user => {
          this.currentUser = user;
        }
      );
    this.loadApplication();
    this.loadUsers();
  }

  initializeData() {
    this.loadApplication();
  }

  loadApplication() {
    this.applicationService.getById(this.currentUser.clientId)
      .subscribe(
        (res: IClientModel) => {
          this.application = res;
          console.log('client', res);
        });
  }

  appContainString(app: IClientModel): boolean {
    const text = app.name;
    const textLower = text.toLowerCase();
    if (textLower.search(this.searchParamApp.toLowerCase()) > -1) {
      return true;
    }
    return false;
  }

  clearAppSearch() {
    if (this.searchParamApp != '') {
      this.searchParamApp = '';
    }
  }

  showUsers(application: IClientModel) {
    this.selectedApp = application;
    this.sharedData.appId = this.selectedApp;
    this.page = 1;
    this.searchParam = '';
    this.selectedUser = null;
    this.loadUsers();
  }

  loadUsers() {
    this.userService.getByApplicationId(this.currentUser.clientId)
      .subscribe(
        (res: IUser[]) => {
          this.users = res;
          this.usersDataSearch = res;
          this.checkStatus(this.usersDataSearch);
          this.applyFilter();     
        });
  }
  
  applyFilter() {
    this.getFilteredUsers();
  }

  getFilteredUsers() {
    const filteredByOfflineStatus = this.users.filter(user => {
      if (!this.selectedFilter) {
        return true;
      }
      const currentDate = new Date();
      currentDate.setHours(23, 59, 59, 999); // Set the time to 00:00:00
      const offlineDuration = (currentDate.getTime() - new Date(user.lastTimeOnline).getTime()) / (1000 * 3600 * 24);
      return offlineDuration > this.selectedFilter;
    });

    this.usersDataSearch = filteredByOfflineStatus.filter(user =>
      user.name?.toLowerCase().includes(this.searchParam.toLowerCase()) ||
      user.email?.toLowerCase().includes(this.searchParam.toLowerCase())
    );
  }

  selectFilter(value: number | null): void {
    this.selectedFilter = value;
    this.getFilteredUsers();
  }

  checkStatus(users: IUser[]) {
    this.util.checkStatus(users);
  }

  jumpToPage(event: any) {
    if (event.srcElement && event.srcElement.localName === 'input') {
      if(event.target.value !== ''){
        if (isNaN(event.target.value)) {
          this.translate.get('errors.pleaseEnterNumber').subscribe((text: string) => {
            this.toastr.error(text);
          });
          return false;
        }
      }
      const page = parseInt(event.target.value, 10);
      const maxPage = Math.ceil(this.usersDataSearch.length / this.perPage);

      if (event.target.value === '' || page === this.page || page > maxPage) { return; }

      this.page = parseInt(event.target.value, 10);
    } else {
      this.page = event;
    }
    this.sharedData.userPage = this.page;
    // this.page == 1 ? this.changeQuery({ 'page': null }) : this.changeQuery({ 'page': this.page });
  }

  clearSearch() {
    if (this.searchParam !== '') {
      this.searchParam = '';
      this.applyFilter();
    }
  }

  async openAddUserModal() {
    return await this.dialogAddUser.open()
  }

  sendUser(data) {
    const formValue = data.form.form.value; 
    if (data.toggleNewClient) {  
      const {
        nameClient,
        description,
      } = formValue;

      const body = {
        name: nameClient,
        description
      };
 
      this.applicationService.addClientAsCustomer(body, this.currentUser.customerId)
        .subscribe(
          (response: IClientModel) => {
            this.loadApplication();
            this.createUser(formValue, response.id);
            this.toastr.success("User added successfully");
          },
          error => {
            
            this.translate.get('errors.errorCreatingApplication').subscribe((text: string) => {
              this.toastr.error(text);
            });
          });
    } else {
      this.createUser(formValue);
      this.toastr.success("User added successfully");
    }
  }

  createUser(form, newClientId?: string) {
    const {
      fullName,
      email,
      password,
      type,
    } = form;

    let additionalInvoiceInfo;
    form.additionalInvoiceInfo === ''
      ? (additionalInvoiceInfo = undefined)
      : (additionalInvoiceInfo = form.additionalInvoiceInfo);
      
    const body = {
      name: fullName,
      email,
      password,
      type,
      additionalInvoiceInfo
    };

    // newClientId ? body['clientId'] = newClientId : body['clientId'] = clientId;

    this.clientService.addUser(body, this.currentUser.clientId)
      .subscribe(
        res => {
          // this.userService.patchUserMaxCount(response.id, 12).subscribe(res => {
          //   this.translate.get('customer.userAdded').subscribe((text: string) => {
          //     this.toastr.success(text);
          //   });
          //   this.toggleAddUser = false;

          //   const sameClient = this.selectedApp.id === response.clientId;

          //   if (sameClient) { // Push if we add user to the same opened client, else don't push
          //     this.usersDataSearch.push(res);
          //     this.users.push(res);

          //     this.checkStatus(this.usersDataSearch);
          //     this.loadProfilePicture(this.usersDataSearch)
          //     this.applyFilter();
          //   }
          // }, err => {
          //   
          //   this.translate.get('customer.tokenError').subscribe((text: string) => {
          //     this.toastr.warning(text);
          //   });
          //   this.toggleAddUser = false;

          //   const sameClient = this.selectedApp.id === response.clientId;

          //   if (sameClient) { // Push if we add user to the same opened client, else don't push
          //     this.usersDataSearch.push(response);
          //     this.users.push(response);

          //     this.checkStatus(this.usersDataSearch);
          //     this.loadProfilePicture(this.usersDataSearch)
          //     this.applyFilter();
          //   }
          // });

          this.usersDataSearch.push(res);
          this.users.push(res);

          this.checkStatus(this.usersDataSearch);
          this.applyFilter();
          this.toggleAddUser = false;
          this.dialogAddUser.close();
          

        },
        error => {
          this.toastr.error(error.message);
        });
  }
  
  selectedUser
  deleteUser(userId) {
    this.userService.deleteUser(userId)
      .subscribe(
        response => {
          this.translate.get('customer.deletedUser').subscribe((text: string) => {
            this.toastr.success(text);
          });

          const user = this.usersDataSearch.find(user => user.id === userId);

          if (user !== undefined) {

            if (this.usersDataSearch.indexOf(user) != -1) {
              this.usersDataSearch.splice(this.usersDataSearch.indexOf(user), 1);
            }

            if (this.users.indexOf(user) != -1) {
              this.users.splice(this.users.indexOf(user), 1);
            }
          }

        },
        error => {
          this.toastr.error(error.message);
        });
  }


  navigateToUser(id: string) {
    let data;
    if (this.searchParam !== '') {
      data = { userSearch: this.searchParam };
    } else {
      data = null;
    }
    this.router.navigate(['client/users/' + id + '/profile'], {
      queryParams: data,
      queryParamsHandling: 'merge'
    });
  }

  reloadUserData(res) {
    this.loadUsers();
  }

  handleSortUsers(data) {
    const sort = data.target.value;

    switch (sort) {
      case 'name':
        this.users = this.users.sort((a,b) => a.name?.localeCompare(b?.name));
        this.usersDataSearch = this.usersDataSearch.sort((a,b) => a.name?.localeCompare(b?.name));
        break;
      case 'lastOnline':
        this.users =  this.users.sort((a, b) => {
          return (new Date(b.lastTimeOnline) as any) - (new Date(a.lastTimeOnline) as any);
        });
        this.usersDataSearch = this.usersDataSearch.sort((a, b) => {
          return (new Date(b.lastTimeOnline) as any) - (new Date(a.lastTimeOnline) as any);
        });
        break;
      default:
        break;
    }
  }
}
